import { gql } from '@apollo/client';

export const GET_RECENT_ACTIVITY = gql`
  query RecentActivity(
    $filter: FilterFindManyReducedExamInput!
    $sort: SortFindManyReducedExamInput
  ) {
    recentActivity(filter: $filter, sort: $sort) {
      _id
      examDate
      technology
      priority
      patient {
        _id
        firstName
        lastName
        identificationType
        identificationNumber
      }
      relevantFindingsCount
      detectionsCount
      status
      createdAt
    }
  }
`;
